// Alle teksten in het Nederlands. Dit is de bron: en.ts moet precies dezelfde sleutels en {plaatsvervangers} hebben
// (bewaakt door het type en door i18n.test.ts). Eigennamen van straten, winkels, klanten en katten blijven in de
// kaart staan en worden niet vertaald. Teksten met HTML (alleen <b>) zijn hier bewust, nooit met gebruikersinvoer.
export const nl = {
  // --- Pagina ---
  'meta.title': 'Bak en Bezorg',
  'meta.description': 'Bezorg verse baksels op tijd, warm en heelhuids door de stad. Een spel van Team O.',
  'meta.ogDescription': 'Op tijd, warm en heelhuids. Een bezorgspel van Team O.',
  'canvas.aria': 'De stad, met jouw scooter in het midden',
  'credit': 'Made by Team O • © 2026',

  // --- Woorden die vaker terugkomen ---
  'count.stars_one': '{n} ster',
  'count.stars_other': '{n} sterren',
  'list.and': ' en ',
  'common.done': 'Klaar',
  'common.on': 'Aan',
  'common.off': 'Uit',

  // --- HUD ---
  'hud.clockTitle': 'Klok van je shift',
  'hud.earnedSr': 'Verdiend deze shift:',
  'hud.walletTitle': 'Je portemonnee',
  'hud.walletSr': 'In je portemonnee:',
  'hud.pause': 'Pauze',
  'hud.offers': 'Nieuwe bestellingen',
  'hud.cargo': 'In je bak',
  'hud.guideSkip': 'Uitleg overslaan',
  'hud.thumbZone': 'Sleep met je duim in de richting waarin je wilt rijden',
  'hud.thumbHint': 'Zet je duim neer en sleep waar je heen wilt',
  'hud.joystick': 'Stuur: sleep in de richting waarin je wilt rijden',
  'hud.left': 'Naar links',
  'hud.right': 'Naar rechts',
  'hud.horn': 'Toeter',
  'hud.drift': 'Drift',
  'hud.gas': 'Gas',
  'hud.brake': 'Rem en achteruit',
  'hud.step': 'Stap {n} van {of}: {text}',
  'hud.hintDeliver': 'Volg de pijl naar de klant. Rustig over drempels, en sta even stil bij de deur.',
  'hud.hintLoad': 'Rij naar de oranje cirkel bij de bakkerij en sta even stil om in te laden.',
  'hud.hintAcceptTouch': 'Tik op Aannemen bij een bestelling.',
  'hud.hintAcceptKey': 'Klik op Aannemen of druk op Enter.',

  // --- Bestellingen en lading ---
  'offer.race': '🏁 Race tegen Sjors · +{bonus}',
  'offer.tipLine': '+ fooi · {sec}s',
  'offer.accept': 'Aannemen',
  'offer.full': 'Bak is vol',
  'offer.emptyFirst': 'Maak je bak leeg',
  'offer.decline': 'Weigeren',
  'cargo.pickup': 'Ophalen bij de bakkerij',
  'cargo.time': 'Tijd',
  'cargo.warm': 'Warm',
  'cargo.cold': 'Koud',
  'cargo.care': 'Gaaf',
  'target.load': 'Inladen ({n})',

  // --- Bonnetje ---
  'receipt.late': '⏰ Te laat',
  'receipt.ontime': '✓ Op tijd',
  'receipt.warm': '🔥 Warm {pct}%',
  'receipt.cold': '❄️ Koud {pct}%',
  'receipt.care': '🍰 Gaaf {pct}%',
  'receipt.combo': '🔥 Combo x{n}',
  'receipt.starsAria': '{n} van 5 sterren',

  // --- Startscherm ---
  'start.tagline': 'Op tijd, warm en heelhuids.',
  'start.rank': 'Rang {rank} van {total}',
  'start.stars': '★ {stars}',
  'start.bestDay': 'Beste dag: {money}',
  'start.noBestDay': 'Nog geen beste dag',
  'start.nextRank': 'Nog {stars} tot {title}: {districts}',
  'start.maxRank': 'Hoogste rang: de hele stad is van jou.',
  'start.resume': '▶ Verder met je shift',
  'start.resumeStatus': '{time} · {money} verdiend',
  'start.startFirst': 'Start je eerste shift',
  'start.start': 'Start je shift',
  'start.daily': '📅 Uitdaging van vandaag',
  'start.dailyEveryone': 'Voor iedereen dezelfde bestellingen',
  'start.dailyBest': 'Beste vandaag: {money}',
  'start.garage': '🛠️ Garage',
  'start.achievements': '🏅 Prestaties',
  'start.freeride': '🛵 Vrij rijden',
  'start.help': '❓ Zo speel je',
  'start.settings': '⚙️ Instellingen',
  'start.install': '📲 Zet op je beginscherm',
  'start.installHelp': "Tik op Delen en kies 'Zet op beginscherm'.",

  // --- Pauze ---
  'pause.title': 'Pauze',
  'pause.subShift': 'De klok staat stil.',
  'pause.subFreeride': 'Vrij rijden: geen klok, geen bestellingen.',
  'pause.resume': 'Verder rijden',
  'pause.stopShift': 'Shift stoppen',
  'pause.stopFreeride': 'Terug naar het menu',

  // --- Afrekening ---
  'report.kicker': 'Einde van je shift',
  'report.title0': 'Morgen beter!',
  'report.title1': 'Netjes gedaan!',
  'report.title2': 'Goed gewerkt!',
  'report.title3': 'Topdag!',
  'report.titleNone': 'Geen leveringen vandaag',
  'report.starsAria': '{n} van 3 dagsterren',
  'report.record': '🏆 Nieuw record!',
  'report.earned': 'Verdiend',
  'report.delivered': 'Bezorgd',
  'report.average': 'Gemiddeld',
  'report.bestCombo': 'Beste combo',
  'report.starsGained': 'Sterren erbij',
  'report.missed': 'Gemist of kwijt',
  'report.nextGoal': 'Volgende dagster bij {money}.',
  'report.allGoals': 'Alle drie de dagsterren gehaald!',
  'report.race': '🏁 Sjors-races: {won} gewonnen, {lost} verloren.',
  'report.dailyBest': '📅 Uitdaging van vandaag: {money}. Dat is je beste van vandaag!',
  'report.dailyOther': '📅 Uitdaging van vandaag: {money}. Je beste van vandaag is {best}.',
  'report.promotion': '⭐ Promotie naar {title}! Vanaf nu bezorg je ook in {districts}.',
  'report.retry': 'Nog een keer proberen',
  'report.next': 'Volgende shift',
  'report.garage': '🛠️ Garage',
  'report.menu': 'Menu',

  // --- Score delen ---
  'report.share': '🔗 Deel je score',
  'report.shareCopied': '✓ Link gekopieerd',
  'report.shareFailed': 'Delen lukt hier niet',
  'report.challengeMet': '🎯 Score van een vriend ({goal}): verslagen!',
  'report.challengeMiss': '🎯 Score van een vriend ({goal}): nog {left} te gaan.',
  'share.text': 'Ik haalde {money} met {count} in Bak en Bezorg. Kun jij dat verslaan?',
  'share.deliveries_one': '{n} bezorging',
  'share.deliveries_other': '{n} bezorgingen',
  'share.title': 'Gedeelde score',
  'share.intro': 'Iemand haalde dit in één shift. Kun jij dat verslaan?',
  'share.introDaily': 'Iemand haalde dit in de uitdaging van {date}. Kun jij dat verslaan?',
  'share.dayStars': 'Dagsterren',
  'share.rank': 'Rang',
  'share.beat': 'Probeer te verslaan',
  'share.playDaily': 'Speel de uitdaging van vandaag',
  'share.otherDay': 'Die uitdaging was van een andere dag. De bestellingen zijn vandaag anders, maar je kunt de score wel proberen te verslaan.',
  'share.hasSaved': 'Je hebt nog een shift open. Maak die eerst af, dan kun je deze score proberen te verslaan.',
  'share.close': 'Sluiten',
  'share.invalidTitle': 'Deze link werkt niet',
  'share.invalidText': 'De gedeelde score is onleesbaar of beschadigd. Vraag om een nieuwe link.',

  // --- Garage ---
  'garage.title': 'Garage',
  'garage.intro': "Euro's koop je mee, sterren geven je toegang. Je bak bepaalt hoeveel je tegelijk meeneemt.",
  'garage.vehicle': 'Voertuig',
  'garage.box': 'Bak',
  'garage.boxOnScooter': 'Bak (op de scooter)',
  'garage.wheels': 'Banden',
  'garage.engine': 'Motor',
  'garage.paint': 'Kleur',
  'garage.paintHint': 'Nieuwe kleuren krijg je met sterren.',
  'garage.chosen': 'Gekozen',
  'garage.choose': 'Kies',
  'garage.needStars': 'Nog {stars} nodig.',
  'garage.needMoney': 'Nog {money} nodig.',
  'garage.lockedFrom': '{name}, vanaf {stars}',
  'garage.capacity_one': '{n} bestelling tegelijk',
  'garage.capacity_other': '{n} bestellingen tegelijk',
  'garage.scooter': 'Scooter',
  'garage.scooterDesc': 'Wendbaar en snel, en kan afsnijden over stoep en gras.',
  'garage.vanDesc': '{capacity} en een koelvak, maar op stoep en gras rij je maar half zo snel.',
  'garage.noBox': 'Geen bak',
  'garage.noBoxDesc': '{capacity}. Koude producten blijven het koudst.',
  'garage.smallBoxDesc': '{capacity}, houdt warm, dempt schokken.',
  'garage.bigBoxDesc': '{capacity}, heel warm, dempt sterk. IJs smelt sneller.',
  'garage.standard': 'Standaard',
  'garage.standardWheelsDesc': 'Prima bij droog weer.',
  'garage.sportWheelsDesc': 'Meer grip in regen, in plassen en op klinkers.',
  'garage.standardEngineDesc': 'Rustig en voorspelbaar.',
  'garage.turboDesc': 'Hogere topsnelheid. Pas op bij drempels.',

  // --- Upgrades en lakkleuren (economy.ts) ---
  'upgrade.box_kleine.name': 'Kleine bak',
  'upgrade.box_kleine.desc': '2 orders tegelijk, houdt warm, dempt schokken.',
  'upgrade.wheels_sport.name': 'Sportvelgen',
  'upgrade.wheels_sport.desc': 'Meer grip in regen en op klinkers.',
  'upgrade.engine_turbo.name': 'Turbo',
  'upgrade.engine_turbo.desc': 'Hogere topsnelheid.',
  'upgrade.box_grote.name': 'Grote warmhoudbak',
  'upgrade.box_grote.desc': '3 orders tegelijk, houdt lang warm, dempt sterk.',
  'upgrade.van.name': 'Bezorgbusje',
  'upgrade.van.desc': '4 orders tegelijk en een koelvak, maar traag over stoep en gras.',
  'paint.dc2626': 'Bakkersrood',
  'paint.d97706': 'Amber',
  'paint.0284c7': 'Hemelsblauw',
  'paint.059669': 'Smaragdgroen',
  'paint.7c3aed': 'Violet',
  'paint.18181b': 'Mat zwart',

  // --- Rangen en wijken ---
  'rank.1': 'Bakkershulpje',
  'rank.2': 'Vaste bezorger',
  'rank.3': 'Meesterkoerier',
  'district.dorpskern': 'Dorpskern',
  'district.campus': 'Campus',
  'district.centrum': 'Centrum',
  'district.haven': 'Havenkwartier',
  'district.oost': 'Oost',
  'district.industrie': 'Industrie',
  'district.zuid': 'Zuid',

  // --- Producten ---
  'product.koffie.name': 'Koffie & appelbollen',
  'product.koffie.tip': 'Haast: koffie koelt snel af.',
  'product.ontbijt.name': 'Ontbijt met croissants',
  'product.ontbijt.tip': 'Warm houden en op tijd zijn.',
  'product.lunch.name': 'Lunch met saucijzenbroodjes',
  'product.lunch.tip': 'Groot en warm: een goede verdiener.',
  'product.brood.name': 'Brood voor de lunchroom',
  'product.brood.tip': 'Stevig: alleen de tijd telt echt.',
  'product.slagroomtaart.name': 'Slagroomtaart met vers fruit',
  'product.slagroomtaart.tip': 'Kwetsbaar: rustig over drempels.',
  'product.petitfours.name': 'Luxe petit fours',
  'product.petitfours.tip': 'Suikerwerk: elke botsing kost geld.',
  'product.ijstaart.name': 'IJstaart',
  'product.ijstaart.tip': 'Smelt snel. Een warmhoudbak maakt het erger.',
  'product.bruidstaart.name': 'Bruidstaart',
  'product.bruidstaart.tip': 'Vult je hele bak. Eén klap en het feest is voorbij.',

  // --- Prestaties ---
  'ach.title': 'Prestaties',
  'ach.count': '{done} van {total}',
  'ach.got': '✓ behaald',
  'ach.eerste_levering.name': 'Eerste klant',
  'ach.eerste_levering.desc': 'Bezorg je eerste bestelling.',
  'ach.perfecte_taart.name': 'Geen deukje',
  'ach.perfecte_taart.desc': 'Bezorg een taart puntgaaf en met 5 sterren.',
  'ach.combo_5.name': 'Op dreef',
  'ach.combo_5.desc': 'Haal een combo van 5 (vijf keer op rij 4 of 5 sterren).',
  'ach.tien_op_een_dag.name': 'Drukke dag',
  'ach.tien_op_een_dag.desc': 'Bezorg 10 bestellingen in één shift.',
  'ach.volle_bak.name': 'Volle bak',
  'ach.volle_bak.desc': 'Bezorg een volle bak van minstens 3 bestellingen helemaal op tijd.',
  'ach.bruidstaart.name': 'Ja, ik wil',
  'ach.bruidstaart.desc': 'Bezorg een bruidstaart met minstens 4 sterren.',
  'ach.sjors_verslagen.name': 'Sneller dan Sjors',
  'ach.sjors_verslagen.desc': 'Wees Sjors van Knus Expres drie keer voor.',
  'ach.topdag.name': 'Topdag',
  'ach.topdag.desc': 'Haal alle drie de dagsterren in één shift.',
  'ach.foutloos.name': 'Met fluwelen handschoenen',
  'ach.foutloos.desc': 'Bezorg minstens 6 bestellingen in één shift zonder schade en zonder boete.',
  'ach.schans.name': 'Over de gracht',
  'ach.schans.desc': 'Spring over de geopende ophaalbrug.',
  'ach.hele_stad.name': 'Kent de hele stad',
  'ach.hele_stad.desc': 'Bezorg in alle zeven wijken.',
  'ach.dagelijks.name': 'Dagelijkse kost',
  'ach.dagelijks.desc': 'Speel de uitdaging van de dag.',

  // --- Instellingen ---
  'settings.title': 'Instellingen',
  'settings.language': 'Taal',
  'settings.languageAuto': 'Automatisch',
  'settings.languageHint': 'Automatisch volgt de taal van je apparaat.',
  'settings.sound': 'Geluid',
  'settings.soundMotor': 'Motor en weer',
  'settings.soundAlarm': 'Sirenes en toeters',
  'settings.soundEffects': 'Effecten',
  'settings.levelLow': 'Zacht',
  'settings.levelNormal': 'Normaal',
  'settings.soundMixHint': 'Zet losse geluiden zachter of uit. Dit hoor je alleen als Geluid aan staat.',
  'settings.theme': 'Dag en nacht',
  'settings.themeDay': 'Dag',
  'settings.themeNight': 'Nacht',
  'settings.themeAuto': 'Automatisch',
  'settings.themeHint': "Automatisch volgt je telefoon, en wordt 's avonds donker.",
  'settings.controls': 'Sturen op een aanraakscherm',
  'settings.controlsAria': 'Sturen',
  'settings.controlsButtons': 'Knoppen',
  'settings.controlsJoystick': 'Joystick',
  'settings.controlsThumb': 'Eén duim',
  'settings.controlsHint': 'Eén duim: sleep waar je heen wilt, gas geven gaat vanzelf.',
  'settings.assist': 'Stuurhulp',
  'settings.assistHint': 'Houdt je recht in de straat als je niet stuurt.',
  'settings.minimap': 'Kaartje in de hoek',
  'settings.colorblind': 'Kleurenblindveilige route',
  'settings.colorblindHint': 'Andere kleuren, en een streep, stippen of symbool dat laat zien hoeveel tijd je nog hebt.',
  'settings.motion': 'Beweging',
  'settings.motionAuto': 'Automatisch',
  'settings.motionLess': 'Minder',
  'settings.motionNormal': 'Normaal',
  'settings.motionHint': 'Minder: geen schudden, flitsen of schermpjes die bewegen.',
  'settings.vibrate': 'Trillen',
  'settings.version': 'Versie {version} · build {build}',
  'settings.versionNone': 'Versie –',
  'settings.upToDate': 'Je hebt de nieuwste versie.',
  'settings.updateReady': 'Er staat een nieuwe versie klaar.',
  'settings.updateNow': 'Nieuwe versie laden',

  // --- Uitleg ---
  'help.title': 'Zo speel je',
  'help.step1': '<b>Neem bestellingen aan.</b> Ze komen tijdens je shift binnen. Je bak bepaalt hoeveel je er tegelijk meeneemt.',
  'help.step2': '<b>Laad in bij de bakkerij.</b> Rij naar de oranje cirkel en sta even stil. Vanaf dan loopt de klok van de klant.',
  'help.step3': '<b>Bezorg op tijd, warm en heel.</b> De ring om de klant toont je tijd. Drempels en botsingen beschadigen taarten.',
  'help.step4': '<b>Verdien munten</b> en koop in de garage een grotere bak, betere banden of het busje.',
  'help.keyboard': 'Toetsenbord',
  'help.keys': 'Pijltjes of WASD rijden · Spatie drift · H toeter · Enter aannemen · X weigeren · Esc pauze',
  'help.understood': 'Begrepen',

  // --- Politie en boetes ---
  'fine.police': '👮 Politie',
  'fine.title': 'Bekeuring',
  'fine.total': 'Totaal',
  'fine.pay': 'Betalen',
  'fine.contest': 'Uitleggen (kans op halve boete)',
  'fine.rood_licht.title': 'Door rood licht gereden',
  'fine.rood_licht.line1': 'Niet stoppen voor rood licht',
  'fine.rood_licht.line2': 'Administratiekosten',
  'fine.rood_licht.quote': 'De flitspaal zag je door rood rijden. Dat is gevaarlijk voor fietsers en voetgangers.',
  'fine.kat.title': 'Kat aangereden',
  'fine.kat.titleNamed': 'Kat aangereden: {cat}',
  'fine.kat.line1': 'Roekeloos rijden',
  'fine.kat.line2': 'Dierenambulance',
  'fine.kat.quote': 'Katten hebben in deze buurt altijd voorrang. Rij voortaan rustiger.',
  'fine.neighbourCat': 'de buurtkat',
  'fine.hitCat': '🚨 {cat} aangereden! De politie komt eraan.',
  'fine.flash': '📸 Geflitst bij {place}: door rood gereden!',
  'fine.halved': '👮 Goed verhaal: boete gehalveerd naar €{amount}',
  'fine.notBelieved': '👮 De agent gelooft je niet: €{amount}',
  'fine.paid': '👮 Boete betaald: €{amount}',

  // --- Meldingen tijdens het spel ---
  'toast.achievement': '🏅 {name}! +{money}',
  'toast.firstDelivery': '🎉 Eerste levering! Vanaf nu komen er meer bestellingen tegelijk.',
  'toast.full': 'Je bak is vol ({n}). Bezorg eerst, of koop een grotere bak.',
  'toast.bridalAlone': 'Een bruidstaart gaat alleen mee: je bak moet leeg zijn.',
  'toast.expired': 'Deze bestelling is al verlopen.',
  'toast.raceStart': '🏁 Sjors wil dezelfde klant! Wie het eerst is, wint.',
  'toast.raceLost': '😤 Sjors was eerder: die bestelling ben je kwijt.',
  'toast.raceWon': '🏁 Sjors verslagen! +{money}',
  'toast.loaded': 'Ingeladen: {items} — de klok loopt!',
  'toast.promotion': '⭐ Promotie: {title}! Nieuwe wijken vanaf je volgende shift.',
  'toast.shock': '💥 {reason}: −{pct}% gaaf',
  'toast.district': '📍 {name}',
  'toast.bridgeUp': '🌉 De brug gaat omhoog: omrijden of wachten{note}',
  'toast.bridgeDown': '🌉 De brug is weer dicht',
  'toast.extraSeconds': ' (+{n} s erbij)',
  'shock.bump': 'Drempel te hard',
  'shock.collision': 'Botsing',
  'shock.pion': 'Pion geraakt',
  'shock.portier': 'Portier geraakt',
  'shock.auto': 'Auto geraakt',
  'shock.kat': 'Kat geraakt',
  'shock.other': 'Schok',
  'float.stunt': '🛹 Schanssprong!',
  'float.overCanal': 'Over de gracht!',
  'float.boost': '💨 Boost!',
  'float.slalom': '⚡ File-slalom: +12s',
  'float.raceLost': '🏁 Sjors wint!',
  'float.loaded': '🥖 Vers ingeladen!',
  'float.reward': '{label} +{money}',

  // --- Gebeurtenissen ---
  'event.bui.warn': 'Over {sec} seconden begint het te regenen: warm eten koelt dan sneller af.',
  'event.bui.start': 'Het regent: rij rustig, het wegdek is glad.',
  'event.bui.end': 'De bui is voorbij.',
  'event.mist.warn': 'Over {sec} seconden komt er mist.',
  'event.mist.start': 'Mist: je ziet minder ver, let op het verkeer.',
  'event.mist.end': 'De mist trekt op.',
  'event.markt.warn': 'Over {sec} seconden gaat de {street} dicht voor de markt.',
  'event.markt.start': '{street} is afgesloten: neem een omweg.',
  'event.markt.end': 'De markt is weg: de straat is weer open.',
  'event.markt.name': 'Markt op de {street}',
  'weather.sunny': '☀️ Het klaart op',
  'weather.rain': '🌧️ Regen: glad wegdek, warm eten koelt sneller af',
  'weather.mist': '🌫️ Mist: minder zicht, rij rustig',

  // --- Geleide eerste minuut ---
  'guide.deliverNear': 'Sta even stil bij de deur: de klant haalt zijn bestelling op.',
  'guide.deliver': 'Volg de pijl naar de klant en rij rustig over drempels.',
  'guide.loadNear': 'Blijf even stilstaan: je bak wordt ingeladen.',
  'guide.load': 'Rij naar de oranje cirkel bij de bakkerij.',
  'guide.acceptTouch': 'Tik op Aannemen bij de bestelling.',
  'guide.acceptKey': 'Klik op Aannemen of druk op Enter.',

  // --- Tekst in de wereld (canvas) ---
  'world.speedCamera': 'FLITSMEISTER: Flitspaal over {m}m',
  'world.speedWarning': '⚠️ MATIG SNELHEID! Boete dreigt!',
  'world.location': 'Locatie: {place}',
  'world.detourLeft': '◀ OMLEIDING',
  'world.detourRight': 'OMLEIDING ▶',
  'world.jam': '⚠️ FILE • 30 KM/U',
  'world.slalomActive': '⚡ SLALOM ACTIEF!',
  'world.slalom': 'SLALOM VOOR TIJD',
  'world.rival': 'RIVAAL BEZORGDIENST',
  'world.policeChase': '🚨 POLITIE (Achtervolging!)',
  'world.police': '👮 Politie',
  'world.policeCaps': 'POLITIE',
  'world.market': '🛒 MARKT',
  'world.speedCameraPole': '📸 FLITSPAAL',
  'world.loadingZone': 'LAADZONE',
  'world.bridgeLifted': '🛹 SCHANS OPEN: WAAG DE SPRONG MET VOL GAS!',
  'world.bridgeLights': '⚠️ BRUGLICHTEN ACTIEF VOOR SCHEEPSVAART',
  'world.bakeryTagline': 'Ambachtelijke Bakkerij & Hoofdkwartier',
  'world.grain': 'GRAAN',
  'world.bakery': '🥖 BAKKERIJ',
  'cat.crossing': ' 🚸 (Steekt over)',

  // --- Praatwolkjes van katten, auto's en politie ---
  'chat.cat.scared': '🙀 "Miauw!"',
  'chat.cat.wait1': '👀 *Wacht op auto...*',
  'chat.cat.wait2': '🚗 *Laat auto voorbijgaan*',
  'chat.cat.wait3': '🐾 *Kijkt links en rechts*',
  'chat.cat.wait4': '🛑 *Keurig wachten voor de weg*',
  'chat.cat.cross': '✨ *Weg is vrij! Steekt over...*',
  'chat.cat.crossed': '🐾 *Veilig overgestoken!*',
  'chat.cat.sniff': '🐾 *Snuffelt aan bloempot*',
  'chat.cat.wash': '😺 *Wast snuitje*',
  'chat.cat.purr': '💤 *Spint tevreden*',
  'chat.cat.stretch': '🐾 *Rekt zich lekker uit*',
  'chat.rival': '⚡ Sjors (Knus Expres): "Geef gas, Knus & Krokant haalt ons nooit in!"',
  'chat.car1': '👍 "Ik ga al aan de kant!"',
  'chat.car2': '🥐 "Succes met de bezorging!"',
  'chat.car3': '🚗💨 "Rij maar voorbij, koerier!"',
  'chat.car4': '🥖 "Lekker bezig, Knus & Krokant!"',
  'chat.car5': '👋 "Goede rit gewenst!"',
  'chat.police1': '🚨 "HALT! Politie Knusseveld! Stop je scooter!"',
  'chat.police2': '📢 "Aan de kant! Stop onmiddellijk!"',
  'chat.police3': '👮‍♂️ "Stop in naam der wet!"',
  'chat.police4': '🚨 "Aanrijding met dorpskat geregistreerd! Stop!"',

  // --- Updates en offline ---
  'update.title': 'Nieuwe versie beschikbaar',
  'update.text': 'Laad hem wanneer het jou uitkomt; je voortgang blijft bewaard.',
  'update.reload': 'Vernieuwen',
  'update.later': 'Later',
  'analytics.title': 'Anonieme statistieken',
  'analytics.ask': 'Mag ik anoniem bijhouden hoe het spel gebruikt wordt? Zo kan ik het verbeteren.',
  'analytics.desc': 'Anoniem bezoek en speelduur, om het spel te verbeteren. Je voortgang blijft op je toestel.',
  'analytics.allow': 'Toestaan',
  'analytics.deny': 'Niet nu',
  'offline.banner': 'Offline: het spel werkt gewoon door, je voortgang blijft bewaard.',
  'offline.back': 'Weer online.',
} as const;

export type MessageKey = keyof typeof nl;
